/**
 * Mega Menu Fullscreen - Style Zara/H&M
 * JavaScript per interazioni e animazioni
 */

class MegaMenu {
  constructor() {
    this.menu = document.querySelector('[data-mega-menu]');
    this.trigger = document.querySelector('[data-mega-menu-trigger]');
    this.closeButtons = document.querySelectorAll('[data-mega-menu-close]');
    this.submenuTriggers = document.querySelectorAll('[data-submenu-trigger]');
    this.submenuBackButtons = document.querySelectorAll('[data-submenu-back]');
    this.header = document.querySelector('[data-header-main]');
    
    this.isOpen = false;
    this.activeSubmenu = null;
    this.lastScrollY = 0;
    this.scrollThreshold = 50;
    
    this.init();
  }
  
  init() {
    if (!this.menu || !this.trigger) return;
    
    this.bindEvents();
    this.initStickyHeader();
    this.initSearch();
  }
  
  bindEvents() {
    // Toggle menu
    this.trigger.addEventListener('click', () => this.toggle());
    
    // Close buttons
    this.closeButtons.forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });
    
    // Submenu triggers
    this.submenuTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        const submenuId = e.currentTarget.getAttribute('data-submenu-trigger');
        this.openSubmenu(submenuId);
      });
    });
    
    // Back buttons
    this.submenuBackButtons.forEach(btn => {
      btn.addEventListener('click', () => this.closeSubmenu());
    });
    
    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (this.isOpen) {
          if (this.activeSubmenu) {
            this.closeSubmenu();
          } else {
            this.close();
          }
        }
        // Chiudi anche la ricerca se aperta
        const searchOverlay = document.querySelector('[data-search-overlay]');
        if (searchOverlay && searchOverlay.classList.contains('is-open')) {
          this.closeSearch();
        }
      }
    });
    
    // Close on resize (if needed)
    window.addEventListener('resize', this.debounce(() => {
      if (window.innerWidth > 1024 && this.isOpen) {
        // Optional: close on large screens
      }
    }, 250));
  }
  
  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
  
  open() {
    this.isOpen = true;
    this.menu.classList.add('is-open');
    document.body.classList.add('mega-menu-open');
    
    // Trap focus inside menu
    this.trapFocus();
    
    // Announce to screen readers
    this.menu.setAttribute('aria-hidden', 'false');
  }
  
  close() {
    this.isOpen = false;
    this.menu.classList.remove('is-open');
    document.body.classList.remove('mega-menu-open');
    
    // Release focus trap
    this.releaseFocus();
    
    // Close any open submenu after animation
    setTimeout(() => {
      this.closeAllSubmenus();
    }, 500);
    
    // Announce to screen readers
    this.menu.setAttribute('aria-hidden', 'true');
    
    // Return focus to trigger
    this.trigger.focus();
  }
  
  openSubmenu(id) {
    const submenu = document.querySelector(`[data-submenu="${id}"]`);
    if (!submenu) return;
    
    // Close any open submenu first
    this.closeAllSubmenus();
    
    // Open the new submenu
    submenu.classList.add('is-active');
    this.activeSubmenu = submenu;
    
    // Focus first focusable element
    const firstFocusable = submenu.querySelector('button, a');
    if (firstFocusable) {
      setTimeout(() => firstFocusable.focus(), 100);
    }
  }
  
  closeSubmenu() {
    if (this.activeSubmenu) {
      this.activeSubmenu.classList.remove('is-active');
      this.activeSubmenu = null;
    }
  }
  
  closeAllSubmenus() {
    document.querySelectorAll('.mega-menu__submenu').forEach(sub => {
      sub.classList.remove('is-active');
    });
    this.activeSubmenu = null;
  }
  
  initStickyHeader() {
    if (!this.header) return;
    
    window.addEventListener('scroll', this.throttle(() => {
      const currentScrollY = window.scrollY;
      
      // Add scrolled class dopo una soglia minima
      if (currentScrollY > this.scrollThreshold) {
        this.header.classList.add('is-scrolled');
      } else {
        this.header.classList.remove('is-scrolled');
      }
      
      // Nascondi/mostra allo scroll
      if (currentScrollY > this.lastScrollY && currentScrollY > 150) {
        // Scrolling down - nascondi
        this.header.classList.add('is-hidden');
      } else {
        // Scrolling up - mostra
        this.header.classList.remove('is-hidden');
      }
      
      this.lastScrollY = currentScrollY;
    }, 10), { passive: true });
  }
  
  // ==================
  // SEARCH FUNCTIONALITY
  // ==================
  
  initSearch() {
    const searchTrigger = document.querySelector('[data-search-trigger]');
    const searchOverlay = document.querySelector('[data-search-overlay]');
    const searchClose = document.querySelector('[data-search-close]');
    const searchInput = document.querySelector('[data-search-input]');
    const searchClear = document.querySelector('[data-search-clear]');
    
    if (!searchTrigger || !searchOverlay) return;
    
    // Open search
    searchTrigger.addEventListener('click', () => {
      this.openSearch();
    });
    
    // Close search
    if (searchClose) {
      searchClose.addEventListener('click', () => {
        this.closeSearch();
      });
    }
    
    // Clear search input
    if (searchClear && searchInput) {
      searchClear.addEventListener('click', () => {
        searchInput.value = '';
        searchInput.focus();
        searchClear.classList.remove('is-visible');
      });
      
      // Show/hide clear button
      searchInput.addEventListener('input', () => {
        if (searchInput.value.length > 0) {
          searchClear.classList.add('is-visible');
        } else {
          searchClear.classList.remove('is-visible');
        }
      });
    }
    
    // Close on overlay click
    searchOverlay.addEventListener('click', (e) => {
      if (e.target === searchOverlay) {
        this.closeSearch();
      }
    });
  }
  
  openSearch() {
    const searchOverlay = document.querySelector('[data-search-overlay]');
    const searchInput = document.querySelector('[data-search-input]');
    
    if (!searchOverlay) return;
    
    searchOverlay.classList.add('is-open');
    document.body.classList.add('search-open');
    
    // Focus input
    if (searchInput) {
      setTimeout(() => searchInput.focus(), 100);
    }
  }
  
  closeSearch() {
    const searchOverlay = document.querySelector('[data-search-overlay]');
    const searchInput = document.querySelector('[data-search-input]');
    const searchClear = document.querySelector('[data-search-clear]');
    
    if (!searchOverlay) return;
    
    searchOverlay.classList.remove('is-open');
    document.body.classList.remove('search-open');
    
    // Clear input
    if (searchInput) {
      searchInput.value = '';
    }
    if (searchClear) {
      searchClear.classList.remove('is-visible');
    }
  }
  
  trapFocus() {
    const focusableElements = this.menu.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    
    if (focusableElements.length === 0) return;
    
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    
    this.handleTrapFocus = (e) => {
      if (e.key !== 'Tab') return;
      
      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    };
    
    document.addEventListener('keydown', this.handleTrapFocus);
    
    // Focus first element
    setTimeout(() => firstElement.focus(), 100);
  }
  
  releaseFocus() {
    if (this.handleTrapFocus) {
      document.removeEventListener('keydown', this.handleTrapFocus);
    }
  }
  
  // Utility: Debounce
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  // Utility: Throttle
  throttle(func, limit) {
    let inThrottle;
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  new MegaMenu();
});

// Also initialize if using Shopify's Section Rendering API
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-mega-menu]')) {
      new MegaMenu();
    }
  });
}
